import {
  ArrowRightIcon,
  DocumentReportIcon,
  LightningBoltIcon,
  PuzzleIcon,
  SearchIcon,
} from "@heroicons/react/outline";

const networkData = [
  {
    id: 1,
    title: "Apps and integrations",
    desc: "Streamline work by connecting Slack with other services like Google Drive, Office 365 and over 2,200 more.",
    Icon: PuzzleIcon,
  },
  {
    id: 2,
    title: "Workflow Builder",
    desc: "Automate routine actions and communication, so you can get back to the kind of work only humans can do.",
    Icon: LightningBoltIcon,
  },
];

const networkSmallCard = [
  {
    id: 1,
    title: "Messaging",
    Icon: SearchIcon,
    Arrow: ArrowRightIcon,
  },
  {
    id: 2,
    title: "Accessibility",
    Icon: DocumentReportIcon,
    Arrow: ArrowRightIcon,
  },
];

export { networkData, networkSmallCard };
